export const faTexts = {
  // Titles
  encyclopediaTitle: "دارالفرشته - دانشنامه",
  insuranceAndServicesTitle: "دارالفرشته - بیمه و خدمات",
  generatorTitle: "دارالفرشته - چیدمان فرش",

  home: "خانه",
  menu: "منو",
  contactUs: "ارتباط با ما",
  loginRegister: "ورود / ثبت نام",
  encyclopedia: "دانشنامه",
  vr: "واقعیت مجازی",
  buy: "خرید",
  loading: "در حال بارگذاری ...",
  rugGenerate: "چیدمان فرش",
  insuranceAndServices: "بیمه و خدمات",
  insurance: "بیمه",
  brand: "برند",
  shaneh: "شانه",
  density: "تراکم",
  yarn: "جنس",
  rug_size_6: "6 متری",
  rug_size_9: "9 متری",
  rug_size_12: "12 متری",
  decoration: "دکوراسیون",
  room_services: "سرویس ها",
  floor_covering: "کفپوش",
  wall: "دیوار",
  roof: "سقف",
  selectImage: "انتخاب تصویر",
  wishListText:
    "شما می توانید فرش های جدید شده را به لیست علاقه مندی ها اضافه کنید تا در مرحله بعد پیش نمایشی از آنها را ببینید",
  services: "خدمات",
  specialPosts: "مطالب منتخب",
  preview: "پیش نمایش",
  lachakToranj: "لچک ترنج",
  modern: "مدرن",
  afshan: "افشان",
  kheshti: "خشتی",
  your_picture: "تصویر",
  border: "حاشیه",
  corner: "لچک",
  background: "زمینه",
  toranj: "ترنج",
  tile: "زمینه",
  pattern: "طرح",
  rugSettings: "کاشی",
  wishList: "لیست مورد علاقه",
  addToWishList: "افزودن به لیست مورد علاقه",
  listIsEmpty: "لیست خالی است",
  rotate: "چرخش",
  clear: "پاک کردن",
  latest: "جدیدترین",
  oldest: "قدیمی ترین",
  onSale: "حراج",
  searchingForSellers: "در حال جستجو برای فروشنده ها ...!",
  storesForThisRug: "فروشگاه هایی که این فرش را دارند",
  noStoreForSelectedRug: "فروشگاهی برای فرش انتخابی وجود ندارد!",
  selectOneSimilarRug: "لطفا یکی از فرش های مشابه را انتخاب کنید!",
  selectedRugs: "فرش های انتخاب شده",
  rugSimilarityPercentage: "درصد تشابه",
  similarRugs: "فرش های مشابه",
  availableRugSizes: "سایز های موجود",
  phoneNumber: "شماره تماس",
  address: "آدرس",
  filters: "فیلتر ها",
  filter: "فیلتر",
  previewEmptyHelpText: "باید یک فرش را به لیست اضافه کنید!",
  camera: "دوربین",
  upload: "بارگذاری",
  selectSizeYourPic: "اندازه فرش",

  // Texts

  landingText: `ایجاد ارزش افزوده برای فرآیند خرید یکی از دغدغه های مهم اهالی هر کسب و کاری است. این ارزش افزوده از سه جهت مهم و قابل بررسی و اقدام است. از نقطه نظر مصرف کننده، از نقطه نظر فروشنده و در نهایت از نقطه نظر تولید کننده. دارالفرشته با هدف ایجاد این ارزش افزوده در یک بستر دیجیتالی و امن پا به میدان گذاشته است. رویکرد ما در دارالفرشته به این نحو است که خرید و فروش "کالای فرش" را در فضای جدید و قابل اعتماد ارائه کنیم.`,
  wikipediaBoldText: `فرق فرش ماشینی با دستباف چیه؟ برای انتخاب یه فرش با کیفیت به چه چیزهایی دقت کنم؟ چطور سایز فرش را انتخاب کنم؟ رنگ بندی فرش مناسب با دکور من کدومه؟ شانه و تراکم توی فرش ماشینی به چه معنی هست؟ رج توی فرش دستباف یعنی چی؟`,
  wikipediaLightText: `اطلاعات کافی قبل از اقدام به خرید یکی از ملزومات خرید هر کالایی به حساب می آید. دارالفرشته در بخش دانشنامه به دنبال پاسخ گویی به سوالات شما و ارائه ی صحیح ترین اطلاعات  در خصوص جنس، طرح، ظرافت، الیاف،رنگ ،ابعاد و طرح و نقش فرش می باشد.`,
  layOutBoldText:
    "ترنج فرش همسایه ام چه شکلی بود؟ قبول داری زمینه فرش شون خیلی به دکور خونه ما می اومد؟ کاش میشد بدون گشتن توی این مغازه تو خونه میشستم و جزئیات فرش ها رو با دقت می دیدم و فروشنده ها را هم خسته نمیکردم.",
  layOutLightText: `چیدمان در دارالفرشته سرویس ویژه و انحصاری ماست برای کسانی که علاقمند هستند با جزئیات فرش خود بازی کرده و نزدیک ترین فرش به انتخابشان را پیدا کرده و از نزدیک ترین فرشگاه به حل سکونتشان تهیه کنند.`,
  VRBoldText:
    "کاش میشد هر چهار تا طرح رو میگفتیم بیاره خونه و ما یکیش رو انتخاب کنیم ،فرش مدرن بیشتر به دکور ما میاد یا سنتی؟ فرش روی پارکت خوب میشه؟ ",
  VRLightText: `شاید برای شما هم پیش آمده که در هنگام خرید فرش از چند طرح خوشتان آمده باشد ولی این امکان برای شما وجود نداشته باشد که تمام این فرش ها را در منزلتان پهن کرده و نمای آنها را با دکوراسیون منزلتان ببینید و بهترین گزینه را انتخاب کنید. دارالفرشته برای این نیاز شما فکرهای زیادی دارد که این مسیر ار با شبیه سازی منزل شما آغاز کرده و ادامه خواهد داد.`,
  shoppingBoldText: `تو میدونی داری از کی خرید میکنی؟ میشه اعتماد کرد، کلاه برداری نباشه؟ از کجا معلوم فرش را بفرستن؟ حضوری بریم بهتر نیست؟`,
  shoppingLightText: ` ایجاد یک بستر امن برای داد و ستد کالا همیشه دغدغه مصرف کننده و فروشنده بوده است.اعتماد در فضای فروش اینترنتی به مراتب پیچیده تر است و این یکی از موانع گسترش این بازار به خصوص در مورد محصولات ارزشمند است. دارالفرشته تلاش نموده است با ایجاد سازو کار های مناسب بستر فروش امن و قابل اعتمادی را برای خرید فرش برای مصرف کنندگان و فروش فرش برای تامین کنندگان را فراهم نماید.`,
  insuranceBoldText:
    "کاش خودشون میبردن قالیشویی مطمئن؟ فرش ماشینی را کجا بدم بشورن که خراب نشه؟ کاش فرش کهنه ما را میگرفتن و با یه مبلغی با فرش نو تعویض میکردن! جایی هست که بتونم امشب برای مراسم فرش اجاره کنم؟ فرش نو هم اجاره میدن؟ ",
  insuranceLightText: `خدمات پس از فروش و ضمانت کالایی ارزشمند مانند فرش خرید را برای هر مشتری لذت بخش تر و مطمئن تر خواهد کرد. دارالفرشته با توجه به نیازهای مشتریان ضمن ارائه خدمات مختلف پس از فروش، خدمات ارزشمند دیگری را ارائه میدهد. خدماتی از قبیل شست و شوی رایگان! !تعویض فرش کهنه ی شما با فرش نو! و سرویس اجاره ی فرش برای استفاده کوتاه مدت شما از فرش!!!`,

  insuranceText:
    "همه ی ما علاقمندیم از جایی خرید کنیم که هم در زمان خرید بهترین گزینه ها را در اختیارمان بگذارد هم بعد از خرید از خدمات پس از فروش خوبی برخوردار باشد. دارالفرشته در این موضوع نیز خدمات گوناگونی را ارائه میدهد. به طور مثال مصرف کننده ای که فرش همراه با بیمه از دارالفرشته خریداری کرده باشد میتواند از اولین شست و شوی رایگان فرش اش بهره ببرد و یا بعد از مدتی اگر از فرش و انتخاب خود منصرف شد بواسطه ی دارالفرشته فرش کهنه را با پرداخت مبلغی بسیار کمتر از قیمت اولیه، با فرش نو و انتخاب جدید جایگزین کند. گزینه ی دیگر ما در خدمات بحث اجاره ی فرش خواهد بود که بزودی از جزئیات آن در دارالفرشته با خبر خواهید شد.",
  servicesText:
    "همه ی ما علاقمندیم از جایی خرید کنیم که هم در زمان خرید بهترین گزینه ها را در اختیارمان بگذارد هم بعد از خرید از خدمات پس از فروش خوبی برخوردار باشد. دارالفرشته در این موضوع نیز خدمات گوناگونی را ارائه میدهد. به طور مثال مصرف کننده ای که فرش همراه با بیمه از دارالفرشته خریداری کرده باشد میتواند از اولین شست و شوی رایگان فرش اش بهره ببرد و یا بعد از مدتی اگر از فرش و انتخاب خود منصرف شد بواسطه ی دارالفرشته فرش کهنه را با پرداخت مبلغی بسیار کمتر از قیمت اولیه، با فرش نو و انتخاب جدید جایگزین کند. گزینه ی دیگر ما در خدمات بحث اجاره ی فرش خواهد بود که بزودی از جزئیات آن در دارالفرشته با خبر خواهید شد.",

  Custom_Your_Carpet: "طراحی فرش سفارشی",
  image_registration: "ثبت تصویر",
  zoom: "بزرگنمایی",
  confirmation_and_approval: "تایید و ادامه",
  name_and_lastname: "نام و نام خانوادگی",
  Phone_call: "تلفن تماس",
  Address: "آدرس",
  send: "ارسال",
  ordering: "مرتب سازی",
  carpet_show: "نمایش فرش",
  back_market: "بازگشت به بازار",
  next: "بعدی",
  previous: "قبلی",
  carpet_link: "لینک فرش مورد نظرتان",
  national_Code: "کد ملی",
  upload_photo_and_video: "آپلود عکس و ویدیو از فرش خودتان",
  photoـorـvideoـlink: "لینک عکس یا فیلم",
  coming_back: "بازگشت",
  the_link_of_the_carpet_you_want: "لینک فرش مورد نظرتان",
  landing_tab:
    "برای معرفی کامل هر بخش از منو بالا و همچنین برای دسترسی سریعتر از منو پایین پایین استفاده کنید.",
  carpet_replacement: "تعویض فرش",
  submit: "ارسال",
  receiving_information: "در حال دریافت اطلاعات",
  // login form
  login_register_tab_login: "ورود",
  login_register_tab_register: "ثبت نام",
  login_register_input_email: "ایمیل",
  login_register_input_password: "رمز عبور",
  login_register_input_repassword: "تکرار رمز عبور",
  login_register_btn_close: "بستن",
  login_register_btn_submit_login: "ورود",
  login_register_btn_submit_register: "ثبت نام",
  login_register_btn_exit: "خروج",
  order_input_command: "توضیحات",
  order_btn_submit: "ثبت نهایی",
  preview_btn_open_file_dialog: "بارگزاری تصویر پس‌زمینه",
  preview_btn_show_3d: "سه بعدی",
  preview_btn_totate: "افقی",
  preview_slider_prespective: "پرسپکتیو",
  preview_slider_size: "اندازه",
  preview_slider_angle_up_down: "زاویه بالا و پایین",
  preview_slider_angle_left_right: "زاویه چپ و راست",
  preview_slider_rotate: "چرخش",
  profile_btn: "پروفایل",
  profile_txt_first_name: "نام",
  profile_txt_last_name: "نام خانوادگی",
  profile_txt_phone_number: "شماره تماس",
};
